'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _usageTrackerPublic = require('usage-tracker-public');

var publicTrackerClient = _interopRequireWildcard(_usageTrackerPublic);

var _CommonTrackerProperties = require('pricing-pages-unified-ui/utils/CommonTrackerProperties');

var _CommonTrackerProperties2 = _interopRequireDefault(_CommonTrackerProperties);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = function () {
  return publicTrackerClient.createTracker(_extends({}, _CommonTrackerProperties2.default, {
    isExternalHost: false
  }));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/_PublicUsageTracker.js
// module id = 880
// module chunks = 4